<section class="content">

  <div class="row" style="margin-top: 8%;">
      <div class="col-md-12 text-center">
          
          <div style="margin-bottom: 10px;"><img src="./assets/images/lock-128.png" /></div>
          <p style="font-size: 2.0em">Acesso negado à página solicitada!</p>
          <p style="font-size: 1.3em; color:#808080">Consulte o usuário Administrador do Sistema</p>
          <br />
          <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/home64.png" /></a>
          <p style="color: #808080;">Página Inicial</p>
      </div>


  </div>

</section>
